import { IntegrationType } from '../../../../api/integrations-client/integrations-client.type';
import { PanelList } from '../panel-list';
import { getDataSourceName } from './data-sources.helpers';

type DataSourcesListProps = {
  availableDataSources: IntegrationType[];
  selectedDataSource: IntegrationType | null;
  handleSelectIntegrationType: (dataSource: IntegrationType | null) => void;
  handleDisplayIntegrations: () => void;
};

type DataSource = {
  id: IntegrationType | null;
  name: string;
};
const dataSources: DataSource[] = [
  { id: null, name: getDataSourceName(null) },
  { id: IntegrationType.JIRA, name: getDataSourceName(IntegrationType.JIRA) },
  { id: IntegrationType.ADO, name: getDataSourceName(IntegrationType.ADO) },
  { id: IntegrationType.JDC, name: getDataSourceName(IntegrationType.JDC) },
  { id: IntegrationType.GITHUB, name: getDataSourceName(IntegrationType.GITHUB) },
];
export function DataSourcesList({
  selectedDataSource,
  handleSelectIntegrationType,
  availableDataSources,
  handleDisplayIntegrations,
}: DataSourcesListProps) {
  const handleSelectDataSource = (dataSource: DataSource) => {
    handleSelectIntegrationType(dataSource.id ?? null);
  };

  return (
    <PanelList
      title="Integrations"
      items={[
        dataSources[0],
        ...dataSources.filter((dataSource) => availableDataSources.includes(dataSource.id as IntegrationType)),
      ]}
      selectedItem={dataSources.find((dataSource) => dataSource.id === selectedDataSource) ?? null}
      onSelect={handleSelectDataSource}
      onAddNew={handleDisplayIntegrations}
      getItemId={(dataSource) => dataSource.id ?? ''}
      getItemDisplayText={(dataSource) => dataSource.name}
    />
  );
}
